<template>
  <div class="container">
    <ToastPrime />
     <div class="table-display2">
        <div class="cell-display div2">
          <div class="card">
            <div class="formgrid grid">
             <div class="field col-12 md:col-2 text-left">
               <label for="shipName">{{ $t("shipName") }}</label>
               <p
                 id="shipName"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                ><strong>{{ ship.name }}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
               <label for="shipIMO">{{ $t("imoNumber") }}</label>
               <p
                 id="shipIMO"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               ><strong>{{ ship.imo }}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
               <label for="shipType">{{ $t("shipType") }}</label>
               <p
                 id="shipType"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               ><strong>{{ ship.shipType.name }}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
               <label for="shipGT">{{ $t("grossTonnage") }} - <strong>GT</strong> (t)</label>
               <p
                 id="shipGT"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               ><strong>{{ ship.gt}}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
               <label for="shipDWT">{{ $t("capacityDeadWeight") }} - <strong>DWT</strong> (t)</label>
               <p
                 id="shipDWT"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               ><strong>{{ ship.dwt }}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
               <label for="shipTotalDistance">{{ $t("totalDistance") }} (mn)</label>
               <p
                 id="shipTotalDistance"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               ><strong>{{ ship.totalDistance}}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
               <label for="iceClass">{{ $t("iceClass") }}</label>
               <p
                 id="iceClass"
                 class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
               ><strong>{{ ship.iceClassType.name}}</strong></p>
             </div>
             <div class="field col-12 md:col-2 text-left">
              <label for="labelModType">{{ $t("labelModType") }}</label>
              <p
                id="labelModType"
                class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              ><strong>{{ modification.type.name}}</strong></p>
            </div>
            </div>

            <div class="field col-12 md:col-12 p-2"></div>

            <div class="output-box">
              <div style="display: flex; text-align: left;">
                <div style="text-align: left; padding-right: 20px">
                  <p for="state">{{ $t("intervalsToShow") }}:</p>
                  <DropdownPrime
                    id="state"
                    v-model="intervalSelected"
                    :options="intervalsToShow"
                    class="field col-12 md:col-12"
                  />
                </div>

                <div class="field col-12 md:col-10 p-2">
                  <h2>{{ $t("tableHeader") }}</h2>
                  <div class="field col-12 md:col-12 p-2"></div>

                  <table class="styled-table">
                    <thead>
                      <tr>
                        <th scope="col">{{ $t("ecoYear") }}</th>
                        <th scope="col">{{ $t("ecoCIIindex") }}</th>
                        <th scope="col">{{ $t("ecoETSIndex") }}</th>
                        <th scope="col">{{ $t("ecoFuelEUIndex") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in this.dataToShow" :key="index">

                        <!--Para el año-->
                        <td v-if="(this.intervalSelected=='Corto plazo (año 2-5)') && (data.year >= 2 && data.year <= 5)">
                          {{ data.year }}
                        </td>
                        <td v-if="(this.intervalSelected=='Medio plazo (año 2-10)') && (data.year >= 2 && data.year <= 10)">
                          {{ data.year }}
                        </td>
                        <td v-if="(this.intervalSelected=='Largo plazo (año 2-15)') && (data.year >= 2 && data.year <= 15)">
                          {{ data.year }}
                        </td>
                        
                        <!--Para el índice del CII-->
                        <td v-if="(this.intervalSelected=='Corto plazo (año 2-5)') && (data.year >= 2 && data.year <= 5)">
                          {{ data.indexCII }}
                        </td>
                        <td v-if="(this.intervalSelected=='Medio plazo (año 2-10)') && (data.year >= 2 && data.year <= 10)">
                          {{ data.indexCII }}
                        </td>
                        <td v-if="(this.intervalSelected=='Largo plazo (año 2-15)') && (data.year >= 2 && data.year <= 15)">
                          {{ data.indexCII }}
                        </td>
                

                        <!--Para el índice del ETS-->
                        <td v-if="(this.intervalSelected=='Corto plazo (año 2-5)') && (data.year >= 2 && data.year <= 5)">
                          {{ data.indexETS }}
                        </td>
                        <td v-if="(this.intervalSelected=='Medio plazo (año 2-10)') && (data.year >= 2 && data.year <= 10)">
                          {{ data.indexETS }}
                        </td>
                        <td v-if="(this.intervalSelected=='Largo plazo (año 2-15)') && (data.year >= 2 && data.year <= 15)">
                          {{ data.indexETS }}
                        </td>

                          <!--Para el índice del FuelEU-->
                          <td v-if="(this.intervalSelected=='Corto plazo (año 2-5)') && (data.year >= 2 && data.year <= 5)">
                          {{ data.indexFuelEU }}
                          </td>
                          <td v-if="(this.intervalSelected=='Medio plazo (año 2-10)') && (data.year >= 2 && data.year <= 10)">
                            {{ data.indexFuelEU }}
                          </td>
                          <td v-if="(this.intervalSelected=='Largo plazo (año 2-15)') && (data.year >= 2 && data.year <= 15)">
                            {{ data.indexFuelEU }}
                          </td>
                          
                      </tr>


                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="field col-12 md:col-12 p-2"></div>
            <div style="padding-left: 70%;">
                <ButtonPrime @click="save()" id="add-button" class="button">{{ $t("save") }}</ButtonPrime>
                    &ensp; &ensp; &ensp; &ensp;
                <ButtonPrime @click="cancel()" id="add-button" class="button">{{ $t("cancel") }}</ButtonPrime>
            </div>

            <!--Párrafos para separar-->
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-12 p-2"></div>
            <div class="field col-12 md:col-12 p-2"></div>



          </div>
        </div>
     </div>
  </div>
</template>

<script>
import router from "@/router/index";
import store from "@/store/index";
import ShipService from "@/services/ShipService";
import ModificationService from "@/services/Neobuq/ModificationService";
import { ToastSeverity } from "primevue/api";

export default{

  data(){
    return{
      ship: store.getters.currentShip,
      modification: store.getters.currentModification,

      intervalsToShow : ["Corto plazo (año 2-5)", "Medio plazo (año 2-10)", "Largo plazo (año 2-15)"],
      intervalSelected : "Corto plazo (año 2-5)",

      //arrays auxiliares
      dataCII : [],
      dataFuelEU : [],
      dataETS : [],

      //array que mostraremos en la tabla
      dataToShow : [],

      //del 2023 al 2040 añadir la fecha en la tabla además del n´ñumero
      allYears : [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18],

      /*
      1-2023
      2-2024
      3-2025
      4-2026
      5-2027
      6-2028
      7-2029
      8-2030
      9-2031
      10-2032
      11-2033
      12-2034
      13-2035
      14-2036
      15-2037
      16-2038
      17-2039
      18-2040*/
    }
  },

  created(){
    this.shipService = ShipService.getInstance();


    //cogemos los datos necesarios tanto del barco (caso base) como de la modificación
    //console.log("this.modification")
    //console.log(this.modification)
    //CII
    for(let i=0; i< this.ship.baseCII.length; i++){
      let aux = {year : i+1, valueBase : this.ship.baseCII[i].value, valueMod: this.modification.listCII[i].value }
      this.dataCII.push(aux)
    }

    //console.log("this.dataCII")
    //console.log(this.dataCII)
    //FuelEU
    //aquí tenemos que añadir manualmente el año (1) viendo en qué año está (2023)
    //primero creamos todo el array y luego metemos los datos correspondientes
    let yearAux = 23
    for(let i=0; i< this.allYears.length; i++){

      let yearStr = "20" + yearAux

      let aux = {year : i+1, realYear : yearStr, complianceBalanceBase: 0, complianceBalanceMod: 0}
      this.dataFuelEU.push(aux)
      yearAux++
    }

    //ahora vamos a meter los valores reales que tengamos
    for(let i=0; i < this.dataFuelEU.length; i++){

      for(let j=0; j < this.ship.baseFuelEU.length; j++){

        //si el año es el mismo
        if(this.dataFuelEU[i].realYear == this.ship.baseFuelEU[j].year){
          this.dataFuelEU[i].complianceBalanceBase = this.ship.baseFuelEU[j].complianceBalance
          this.dataFuelEU[i].complianceBalanceMod = this.modification.listFuelEU[j].complianceBalance
        }
      }
    }

    //console.log("this.dataFuelEU")
    //console.log(this.dataFuelEU)

    //ETS
    for(let i=0; i <this.ship.baseETS.length; i++){
      let aux = {year : i+1, emissionRightsBase :  this.ship.baseETS[i].emissionRights, emissionRightsMod : this.modification.listETS[i].emissionRights}
      this.dataETS.push(aux)
    }

    //console.log("this.dataETS")
    //console.log(this.dataETS)

    //creamos el array con los datos que mostraremos en la tabla
    for(let i=0; i <this.allYears.length; i++){
      let aux = {year : i+1, indexCII: 0, indexFuelEU: 0, indexETS: 0}
      this.dataToShow.push(aux)
    }

    //ahora caculamos los índices de ecoeficienci
    this.calc_ecoefficiency_indices()

    //console.log("this.dataToShow")
    //console.log(this.dataToShow)

  },

  methods:{

    calc_ecoefficiency_indices(){
      //console.log("Calculamos todos los indices de ecoeficiencia para todos los años")

      //Para cada año del 2 al 15 (2023-2037) , tenemos que hacer la siguiente fórmula
      // (variableCasoBase - variableModificacion) * (1 + (VAN/(inversionInicial/100)))

      let vanCII = 0
      let vanETS = 0
      let vanFuelEU = 0

      let indexCII = 0
      let indexFuelEU = 0
      let indexETS = 0

      // economicTerm depende del VAN
      let economicTermCII = 0
      let economicTermETS = 0
      let economicTermFuelEU = 0

      let ciiBase = 0
      let ciiMod = 0

      let fuelEUBase = 0
      let fuelEUMod = 0

      let etsBase = 0
      let etsMod = 0

      let initialInvestment = this.modification.economicData.initialInvestment
      //console.log("initialInvestment")
      //console.log(initialInvestment)

      //el segundo término es común para TODO, aunque tiene que calcularse cada año por el VAN; la inversión inicial es igual para todos los años
      for(let i=1; i < this.allYears.length-3; i++){

        //EL CII EMPIEZA A CONTAR EN EL AÑO 2023, EL ETS EN EL AÑO 2024 Y EL FUELEU EN EL AÑOS 2025
        //HACER 3 VANS DIFERENTES SEGÚN LA VARIABLE

        //los años de dataPerYear se cuentan de la misma forma que aquí (1,2,3...15)
        if(i==1){
          ciiBase = this.dataCII[i].valueBase
          ciiMod = this.dataCII[i].valueMod
          vanCII = this.modification.economicData.dataPerYear[i].van
          economicTermCII = Number(( 1 + ((vanCII/initialInvestment)/100)).toFixed(2))
          indexCII = ((ciiBase - ciiMod) * economicTermCII).toFixed(2)
        }else if(i==2){

          ciiBase = this.dataCII[i].valueBase
          ciiMod = this.dataCII[i].valueMod
          vanCII = this.modification.economicData.dataPerYear[i].van
          economicTermCII = 1 + ((vanCII/initialInvestment)/100)
          indexCII = ((ciiBase - ciiMod) * economicTermCII).toFixed(2)

          etsBase = this.dataETS[i].emissionRightsBase
          etsMod = this.dataETS[i].emissionRightsMod
          vanETS = this.modification.economicData.dataPerYear[i-1].van
          economicTermETS = 1 + ((vanETS/initialInvestment)/100)
          indexETS = ((etsBase - etsMod) * economicTermETS).toFixed(2)

        }else if(i>=3){

          ciiBase = this.dataCII[i].valueBase
          ciiMod = this.dataCII[i].valueMod
          vanCII = this.modification.economicData.dataPerYear[i].van
          economicTermCII = 1 + ((vanCII/initialInvestment)/100)
          indexCII = ((ciiBase - ciiMod) * economicTermCII).toFixed(2)

          etsBase = this.dataETS[i].emissionRightsBase
          etsMod = this.dataETS[i].emissionRightsMod
          vanETS = this.modification.economicData.dataPerYear[i-1].van
          economicTermETS = 1 + ((vanETS/initialInvestment)/100)
          indexETS = ((etsBase - etsMod) * economicTermETS).toFixed(2)

          fuelEUBase = this.dataFuelEU[i].complianceBalanceBase / 1000000
          fuelEUMod = this.dataFuelEU[i].complianceBalanceMod / 1000000
          vanFuelEU = this.modification.economicData.dataPerYear[i-2].van
          economicTermFuelEU = 1 + ((vanFuelEU/initialInvestment)/100)
          indexFuelEU = ((fuelEUBase - fuelEUMod) * economicTermFuelEU).toFixed(2)
        }

        // console.log("Año " + i + " - VAN_FuelEU: " + vanFuelEU)
        // console.log("economicTermFuelEU")
        // console.log(economicTermFuelEU)
        // console.log("IndexFuelEU - formula:")
        // console.log("(" + fuelEUBase + " - " + fuelEUMod + ") * " + economicTermFuelEU)
        // console.log( "fuelEUBase - fuelEUMod")
        // console.log( fuelEUBase - fuelEUMod)
        // console.log("IndexFuelEU - res:")
        // console.log(indexFuelEU)


        this.dataToShow[i] = {year : i+1, indexCII: indexCII, indexFuelEU: indexFuelEU, indexETS: indexETS}
      }

    },
    save(){
      //console.log("Guardamos los índices de ecoeficiencia...");

      this.modification.ecoefficiencyIndices = this.dataToShow

      const errors = ModificationService.getInstance().saveModification(
        store.getters.currentShip.id,
        store.getters.currentModification
      );

      if (errors != "") {
        this.showToast(false, "Error guardando la modificación: " + errors);
      } else {
        this.showToast(true, "Modificación salvada correctamente");
      }

    },
    cancel(){
      //console.log("EcoefficiencyForm-cancel", this.ship);
      this.shipService.selectedShip({});
      router.push({ name: "neobuqHome" });
    },
    showToast(successful, message) {
      if (successful) {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: message,
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: ToastSeverity.ERROR,
          closable: false,
          summary: message,
          life: 3000,
        });
      }
    },
  }
}

</script>

<style scoped>

.output-box{
  border-style: solid;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
}

.button{
  height: 70px;
  border-radius: 20px;
  text-align: center;
}

/*PARA LA TABLA */
.styled-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

.styled-table th,
.styled-table td {
  padding: 16px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.styled-table th {
  background-color: #f2f2f2;
}

.styled-table tbody tr:last-child td {
  border-bottom: none;
}

.styled-table tbody tr:hover {
  background-color: #f5f5f5;
}

.input-style{
    border-radius: 5px;
    height: 40px;
    width: 250px;
}

</style>